import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { use } from '../utils';
import { inherit } from '../utils/functional';
import Info from '../info';
import isSrc from '../utils/validate/src'; // Types

var _use = use('icon'),
    sfc = _use[0];

var Icon = function Icon(h, props, slots, ctx) {
  var urlIcon = isSrc(props.name);
  return h("i", _mergeJSXProps([{
    "class": [props.classPrefix, urlIcon ? 'van-icon--image' : props.classPrefix + "-" + props.name],
    "style": {
      color: props.color,
      fontSize: props.size
    }
  }, inherit(ctx, true)]), [slots.default && slots.default(), urlIcon && h("img", {
    "attrs": {
      "src": props.name
    }
  }), h(Info, {
    "attrs": {
      "info": props.info
    }
  })]);
};

Icon.props = {
  name: String,
  size: String,
  color: String,
  info: [String, Number],
  classPrefix: {
    type: String,
    default: 'van-icon'
  }
};
export default sfc(Icon);


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/icon/index.js
// module id = 7
// module chunks = 0 1 2 3 4 5 6 7